import { Component, DoCheck, OnInit } from '@angular/core';
import { HomePageService } from '../homepage.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.page.html',
  styleUrls: ['./../home/home.page.scss'],
})
export class FaqPage implements OnInit, DoCheck {
  web: string;
  year: any;
  formUrl: string;
  loading: boolean;
  loading2: boolean;

  constructor(private homePageService: HomePageService) { }
  submitNewsletterForm() {
    this.homePageService.submitNewsletterForm();
  }

  submitContactForm() {
    this.homePageService.submitContactForm();
  }

  ionViewWillEnter() {
    document.title = 'FAQ | Bank3D';
  }

  ngOnInit() {
    this.web = this.homePageService.web;
    this.year = this.homePageService.year;
    this.formUrl = this.homePageService.formUrl;
    this.homePageService.shared();
  }

  ngDoCheck(): void {
    this.loading = this.homePageService.loading;
    this.loading2 = this.homePageService.loading2;
  }
}
